import React from 'react';
import Lottie from 'react-lottie';
import './Compare_Lottie.css';
import * as animationData from './Compare_Lottie.json';

function Compare_Lottie() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    return (
        <section className='main'>
            <div className='Compare_Lottie_icon'>
                <Lottie className="me-auto"
                    options={defaultOptions}
                />
            </div>
        </section>
    );
}
export default Compare_Lottie;